<template>
  <div class="telemetry-steering-angle-parts">
    <img
      class="telemetry-steering-angle-parts__base"
      :src="require('@/assets/img/RaceVideoPage/telemetry/steering_base.svg')"
      alt=""
    />
    <img
      class="telemetry-steering-angle-parts__handle"
      :style="`transform: rotate(${value * -1}deg)`"
      :src="require('@/assets/img/RaceVideoPage/telemetry/steering_handle.svg')"
      alt=""
    />

    <p class="telemetry-steering-angle-parts__data">
      <span class="telemetry-steering-angle-parts__data__number">{{ Math.floor(viewValue) }}</span>
      <span class="telemetry-steering-angle-parts__data__unit">°</span>
    </p>
    <p class="telemetry-steering-angle-parts__label"><span>Steering</span></p>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー ステアリング操舵角 値セクションのコンポーネント
 */
export default defineComponent({
  name: 'TelemetrySteeringAngleParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * 表示fpsと受信データ間隔の差分ms
     */
    diffMs: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { value } = toRefs(props)
    const { setupIntermediateValue } = useTelemetrySectionUtil()
    const viewValue = setupIntermediateValue(value, props.diffMs)

    return {
      viewValue,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-steering-angle-parts {
  position: absolute;
  left: 50%;
  top: calc(#{min(4.2667vw, 1.333em)} + 14.05em);
  width: 11.6667em;
  height: 11.6667em;
  transform: translateX(-50%);

  &__base {
    position: relative;
    z-index: 1;
    width: 100%;
  }

  &__handle {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transition: all linear $telemetryFps;
    z-index: 1;
  }

  &__data {
    position: absolute;
    left: 0;
    top: 32%;
    width: 100%;
    height: 2em;
    text-align: center;
    line-height: 1.33;
    color: $green-light;
    z-index: 3;

    &::before {
      display: inline-block;
      content: '';
      width: 0.66667em;
    }

    &__number,
    &__unit {
      letter-spacing: 0.02em;
      font-size: 1.5em;
    }
  }

  &__label {
    position: absolute;
    left: 0;
    top: 51%;
    width: 100%;
    text-align: center;
    line-height: 1.33;
    padding-left: 0.1em;
    font-weight: 500;
    color: $white;
    opacity: 0.8;
    z-index: 3;

    span {
      font-size: max(1em, 8px);
    }
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-steering-angle-parts {
      width: 12.08em;
      height: 12.08em;
      top: calc(#{min(4.2667vw, 1.333em)} + 13.5em);

      &__data {
        top: 32%;

        &__number,
        &__unit {
          font-size: 1.7em;
        }
      }

      &__label {
        span {
          font-size: 1.2em;
        }
      }
    }
  }
}
</style>
